import { useEffect, useMemo } from 'react';
import { AxiosRequestConfig } from 'axios';
import { configureAxios } from '@area-restrita/api-client';

import { createAxiosInterceptor } from '../config';

interface IAxiosConfig {
  axiosConfigDefaults?: AxiosRequestConfig;
  getAccessToken?: () => Promise<string | undefined> | string | undefined;
  onUnauthorized?: () => void;
  onForbidden?: () => void;
}

export const configAxios = ({
  axiosConfigDefaults,
  getAccessToken,
  onForbidden,
  onUnauthorized,
}: IAxiosConfig) => {
  const api = configureAxios(axiosConfigDefaults);

  createAxiosInterceptor({
    instance: api,
    getAccessToken,
    onForbidden,
    onUnauthorized,
  });

  return api;
};

export const useConfigAxios = ({
  axiosConfigDefaults,
  getAccessToken,
  onForbidden,
  onUnauthorized,
}: IAxiosConfig) => {
  const api = useMemo(
    () => configureAxios(axiosConfigDefaults),
    [axiosConfigDefaults],
  );

  useEffect(() => {
    const cleanup = createAxiosInterceptor({
      instance: api,
      getAccessToken,
      onForbidden,
      onUnauthorized,
    });

    return () => {
      cleanup();
    };
  }, [api, getAccessToken, onUnauthorized, onForbidden]);
};
